import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentLoaderService } from './environment-loader.service';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  baseUrl: string;

  constructor(
    private http: HttpClient,
    private environmentLoaderService: EnvironmentLoaderService
  ) {
    this.baseUrl = this.environmentLoaderService.config.egisServiceBaseUrl;
  }

  getPortalVersion(): Observable<any> {
    return this.http.get('assets/version.txt', {
      responseType: 'text',
    });
  }

  getServiceVersion(): Observable<any> {
    return this.http.get(this.baseUrl + '/version', {
      responseType: 'text',
    });
  }
}
